import {BASE_URL } from "./Env";


// =============================================== NEW =============
export const APISendFeedback = `${BASE_URL}/api/send-feedback`;
export const APIExtracttText = BASE_URL+"/api/researche/pdf/extract-text"
// password reseting
export const APIVerifyResetToken = BASE_URL+"/api/researcher/verify-reset-token";
export const APIResearcherPasswordRest = BASE_URL+"/api/researcher/reset/password";
export const APIResearcherForgotPassword = BASE_URL+"/api/researcher/password/email";

// Product
export const APIProductStore = BASE_URL+"/api/product/store";
export const APIProductList = BASE_URL+"/api/product/list";
export const APIProductDelete = BASE_URL+"/api/product/delete";
export const APIProductUpdate = BASE_URL+"/api/product/update";
export const APIProductListByName = BASE_URL+"/api/product/by/researcherName/";


// Universities
export const APIUniversitiesList = BASE_URL+"/api/universities/list";
export const APIUniversityStore = BASE_URL+ "/api/universities/store";
export const APIAreasStore = BASE_URL+"/api/categories/store";

// Researcher
export const APIResearcherLogin = BASE_URL+"/api/researcher/login";
export const APIResearcherStore = BASE_URL+ "/api/researcher/store";
export const APIResearcherList = BASE_URL+"/api/researcher/list";
export const APIResearcherDelete = BASE_URL+"/api/researcher/delete";
export const APIResearcherDetails = BASE_URL+"/api/researcher/details";
export const APIUpdateResearcherDetails = BASE_URL+"/api/researcher/update";
export const APIUpdateResearcherPassword = BASE_URL+"/api/researcher/update/password";
export const APIUpdateResearcherImage = BASE_URL+"/api/researcher/update/image";

//  Validation
export const APIResendVerification = BASE_URL+"/api/validate/resend-verification";
export const APIVerificationStatus = BASE_URL+"/api/validate/verification-status";
export const APIValidateEmail = BASE_URL+"/api/validate/validate-email/";


export const APIResearcherGetById = BASE_URL+"/api/ria/research/by/researcherName/";


// Research
export const APIResearchStore = BASE_URL+"/api/research/store";
export const APIResearchUpdate = BASE_URL+"/api/research/update";
export const APIResearchDelete = BASE_URL+"/api/research/delete";
export const APIResearchList = BASE_URL+"/api/research/list";
export const APIResearchCheckSimilarities = BASE_URL+"/api/research/check-similarities";


// Published Works
export const APIPublishedWorkStore = `${BASE_URL}/api/published-work/store`;
export const APIPublishedWorkUpdate = `${BASE_URL}/api/published-work/update`;
export const APIPublishedWorkDelete = `${BASE_URL}/api/published-work/delete`;
export const APIPublishedWorkList = `${BASE_URL}/api/published-work/list`;
export const APIPublishedWorkByAuthor = `${BASE_URL}/api/published-work/author`;
export const APIPublishedWorkShow = `${BASE_URL}/api/published-work/show`;


// Categories
export const APICategoriesList = BASE_URL+"/api/categories/list";
export const APIcategoriesTheme = BASE_URL+"/api/categories/theme";


// Projects
export const APIProjectStore = BASE_URL+"/api/project/store";
export const APIProjectList = BASE_URL+"/api/project/list";
export const APIProjectDelete = BASE_URL+"/api/project/delete";
export const APIProjectUpdate = BASE_URL+"/api/project/update";
export const APIProjectsListByName = BASE_URL+"/api/project/by/researcherName/";

// Research Views
export const APIResearchViewsStore = BASE_URL+"/api/research/views/store";
export const APIResearchViewsList = BASE_URL+"/api/research/views/list";
export const APIResearchViewsDelete = BASE_URL+"/api/research/views/delete";

